import React , {useRef} from "react";
//rtl
import {
    I18nManager,
    BackHandler,
    Alert,
    StyleSheet,
    View,
    ScrollView,
    Dimensions,
    Text,
    StatusBar,
    Image,
    Button,
    TouchableOpacity
} from 'react-native';
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";


import { Feather } from '@expo/vector-icons';





import AsyncStorage from '@react-native-async-storage/async-storage';
import {useFocusEffect, useNavigationState} from "@react-navigation/native";


export default function Welcome({navigation}) {





    let [focused,setFocused] = React.useState(true);

    useFocusEffect(
        React.useCallback(()=>{
            setFocused(true);
            return ()=>{
                setFocused(false);
            }
        },[])
    );
    if(!focused){
        return (<></>);
    }













    const scrollRef = useRef();
    let windowsizewidth = Dimensions.get('window').width;



    const goHome = async ()=>{
        await AsyncStorage.setItem('WelcomeSeen', '1');
        navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
        });
    };


    return (
        <ScrollView
            horizontal={true}
            // snapToInterval ={false}
            decelerationRate={"fast"}
            showsVerticalScrollIndicator ={false}
            showsHorizontalScrollIndicator={false}
            pagingEnabled={true}
            ref={ scrollRef}
            // onScroll={e => console.log(e)}

        >
            <View style={styles.box}>
                <Image
                    style={styles.img}

                    source={require('./../assets/1.jpg')}

                />

                <View style={styles.bx}>
                    <Text style={styles.header} fontSize="3xl">Maxinvest</Text>
                    <Text style={styles.text} fontSize="xl">
                        Welcome to our trading site! We offer the best,profit plans in the trading market.start using the referral link !
                        ©2023 All Rights Reserved By maxInvest
                    </Text>


                    <TouchableOpacity
                        onPress={
                            e=>scrollRef.current.scrollTo({x: (windowsizewidth*1), y: 0})
                        }
                        style={styles.csbtn}>
                        <Text style={styles.btntxt}> Next >> </Text>
                    </TouchableOpacity>

                    <Button color={'#098f83'}  title={''}/>



                </View>

            </View>
            <View style={styles.box}>
                <Image
                    style={styles.img}

                    source={require('./../assets/2.jpg')}

                />

                <View style={styles.bx}>
                    <Text style={styles.header} fontSize="3xl">Meet Our Platform To Know More About</Text>
                    <Text style={styles.text} fontSize="xl">
                        Hey folks! Meet our platform! With our platform, you'll get access to all the info you need to make informed decisions. Our platform is your one-stop-shop for everything you need to know.
                    </Text>


                    <TouchableOpacity
                        onPress={
                            e=>scrollRef.current.scrollTo({x: (windowsizewidth*2), y: 0})
                        }
                        style={styles.csbtn}>
                        <Text style={styles.btntxt}> Next >> </Text>
                    </TouchableOpacity>

                    <Button color={'#098f83'}  title={''}/>



                </View>

            </View>
            <View style={styles.box}>
                <Image
                    style={styles.img}

                    source={require('./../assets/3.jpg')}

                />

                <View style={styles.bx}>
                    <Text style={styles.header} fontSize="3xl">Our Pricings Plan</Text>
                    <Text style={styles.text} fontSize="xl">
                        We chose packages that all people in the society can start their own financial management and risk-taking power!Maximize Your Investment Returns
                    </Text>


                    <TouchableOpacity
                        onPress={
                            e=>scrollRef.current.scrollTo({x: (windowsizewidth*3), y: 0})
                        }
                        style={styles.csbtn}>
                        <Text style={styles.btntxt}> Next >> </Text>
                    </TouchableOpacity>
                    <Button color={'transparent'}  title={''}/>



                </View>

            </View>
            <View style={styles.box}>
                <Image
                    style={styles.img}

                    source={require('./../assets/4.jpg')}

                />

                <View style={styles.bx}>
                    <Text style={styles.header} fontSize="3xl">The number of supported users</Text>
                    <Text style={styles.text} fontSize="xl">
                        Maxinvest is trusted by over 25K users worldwide. Buy and sell 250+ crypto, and earn up to 8.5% p.a. on your crypto with usTrade safely and securely with industry-leading compliance and security certifications, and proof of reserves.
                    </Text>


                    <TouchableOpacity
                        onPress={
                            goHome
                        }
                        style={styles.csbtn}>
                        <Text style={styles.btntxt}>Lets go ! </Text>
                    </TouchableOpacity>

                    <Button color={'#07bdad'}  title={''}/>
                </View>
            </View>
        </ScrollView>


    );
}
const styles = StyleSheet.create({

    bx : {
        flex : 1,
        flexGrow  : 1,
        borderColor : '#FFF',
        borderWidth : 1,
        borderTopLeftRadius : 35,
        borderTopRightRadius : 45,
        // backgroundColor : 'red',

        shadowColor: 'red',
        shadowRadius: 100,
        shadowOpacity: 1,
    },

    csbtn : {
        width : "30%",
        backgroundColor : '#07bdad',
        borderRadius : 10,
        minHeight : RFValue(30),
        justifyContent: "center",
        alignItems: "center",
        margin : RFValue(20),
        alignSelf : 'flex-end'

    },
    btntxt : {
        fontFamily : 'novaria',
        textAlign:'center',

        fontSize:RFValue(13),
        color : '#FFF'
    },

    netbox : {
        flexGrow : 1,
        justifyContent : "center",
        alignItems : 'center',
    },
    nettext : {
        fontFamily : 'iransansdn',
        textAlign:'center',
        marginVertical:RFValue(25),
        fontSize:RFValue(13),
        color : '#555'
    },

    container: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
    },
    scrollView: {
        backgroundColor: 'green',
        marginHorizontal: 0,
        flex:1,

    },
    items : {
        display:"flex",
        flexDirection:'column',
        // width:'100%',
        backgroundColor:'red',
    },
    header : {
        fontFamily : 'novaria',
        // fontWeight : 'bold',
        textAlign:'center',
        padding:RFValue(18),
        fontSize:RFValue(25),

    },
    text : {
        fontFamily : 'novaria',
        textAlign:"justify",
        flexGrow:1,
        paddingTop:RFValue(20),
        paddingHorizontal:RFValue(35),
        fontSize : RFValue(13),
        lineHeight : RFValue(25),



    },
    txtbtn : {
        color : 'white',
        fontFamily:'iransansdn',
        fontSize:15,

    },
    btn : {
        width : Dimensions.get('window').width / 3,
        // alignSelf : "flex-end",
        marginTop:RFValue(30),
        marginLeft: Dimensions.get('window').width / 2,
        marginBottom: RFValue(60),



    },
    box : {
        width : Dimensions.get('window').width ,
        height: Dimensions.get('window').height,
        flex:1,
        flexDirection:'column',
        justifyContent: "flex-start",
        backgroundColor: '#FFF'
    },
    img:{
        backgroundColor:'gray',
        width : Dimensions.get('window').width ,
        height: Dimensions.get('window').height / 2.1,
        marginBottom : RFValue(18),
    }
})
